// extracted by mini-css-extract-plugin
module.exports = {"container":"PdpSharedPromoCode__container__c2addab2"};